// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import replace from 'lodash/replace';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

/**
 * Hard coded sharedId to use for mobile users.
 */
export const DISCOVER_MOBILE_SHARED_ID = '7514664';

/**
 * This utility function searches the destination url for the sharedid
 * query param and replaces its value.
 */
const replaceSharedIdValue = (url, newSharedId) => {
  const newSharedIdParam = `sharedid=${newSharedId}`;
  const currentSharedIdParam = url.match(/[?&](sharedid=(\w|\d)+?)(&|$)/);
  if (currentSharedIdParam) {
    return replace(url, currentSharedIdParam[1], newSharedIdParam);
  }
  return url;
};

/**
 * Helper function that will return a modified destination URL if required for Discover.
 */
export default (req, productType, destinationUrl) => {
  // sharedId should be modified for mobile users viewing Discover Credit Cards.

  const isMobile = get(req, 'headers.x-in-native-app') === '1';
  const isDiscoverDestinationUrl = destinationUrl.includes('goto.discover.com');
  const isCreditCard = productType === 'credit_cards';

  if (isMobile && isDiscoverDestinationUrl && isCreditCard) {
    return replaceSharedIdValue(destinationUrl, DISCOVER_MOBILE_SHARED_ID);
  }

  // If sharedid is provided on the incoming request, replace the current value with the new value.
  const newSharedId = get(req, 'query.sharedid');

  if (newSharedId) {
    return replaceSharedIdValue(destinationUrl, newSharedId);
  }

  return destinationUrl;
};
